import authRepository from '@/api/auth';
import authRepositoryMock from '@/__mocks__/auth.mock';
import bankAccountsRepository from '@/api/bank-accounts';
import bankAccountsRepositoryMock from '@/__mocks__/bankAccountsRepository';
import paymentOrdersRepository from '@/api/payment-orders';
import paymentOrdersRepositoryMock from '@/__mocks__/paymentOrdersRepository';
import directDebitRepositoryMock from '@/__mocks__/directDebitRepository';
import {
  AUTH, BANK_ACCOUNTS, DIRECT_DEBIT, PAYMENT_ORDERS,
} from '@/constants/repository';
import directDebitRepository from '@/api/direct-debit';

const repositories: { [key: string]: any } = {
  [AUTH]: authRepository,
  [BANK_ACCOUNTS]: bankAccountsRepository,
  [PAYMENT_ORDERS]: paymentOrdersRepository,
  [DIRECT_DEBIT]: directDebitRepository,
};

const repositoriesMock: { [key: string]: any } = {
  [AUTH]: authRepositoryMock,
  [BANK_ACCOUNTS]: bankAccountsRepositoryMock,
  [PAYMENT_ORDERS]: paymentOrdersRepositoryMock,
  [DIRECT_DEBIT]: directDebitRepositoryMock,
};

export default {
  get<T>(name: string): T {
    return repositories[name];
  },
};
